import { FunctionComponent } from 'react'
import { useArchiveFloorRule, useFloorRules } from '~/api/app/floor-rules.api'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { ArchivedRulesPage } from './ArchivedRulesPage'

/** The archived floor price rules. The page itself is shared with the other three kinds. */
export const ArchivedFloorPriceRulesPage: FunctionComponent = () => {
  const { canArchive } = useScopePermissions()
  const { data: floorRules, isLoading } = useFloorRules(false, true)
  const { mutateAsync: archiveFloorRule, isPending } = useArchiveFloorRule({ successToast: 'Floor price rule unarchived', errorToast: 'Could not unarchive this floor price rule' })

  return (
    <ArchivedRulesPage
      rules={floorRules}
      isLoading={isLoading}
      noun={'floor price rule'}
      backLabel={'Back to floor price rules'}
      backPath={'/monetization/inventory/floor-price'}
      onUnarchive={(rule) => archiveFloorRule({ id: rule.id, archived: false })}
      isUnarchiving={isPending}
      canUnarchive={canArchive}
      backTrackingLabel={'adm-floor-price-rules-archived-back-navigate'}
      unarchiveTrackingLabel={'adm-floor-price-rules-unarchive'}
    />
  )
}
